import { render, staticRenderFns } from "./LicenceData.vue?vue&type=template&id=4bf7dad4&"
import script from "./LicenceData.vue?vue&type=script&lang=js&"
export * from "./LicenceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports